import React from 'react';
import { Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { arrayOf, string } from 'prop-types';

const NotFound = ({ terms }) => (
  <Message negative>
    <Message.Header>{terms[7]}</Message.Header>
    <p>{terms[8]}</p>
    <Link to="/genres/all">{terms[9]}</Link>
  </Message>
);

NotFound.propTypes = {
  terms: arrayOf(string).isRequired
};

export default NotFound;
